import { getContrastYIQ } from '@oolio-group/design-common';

export const resolveAttributionMode = (
  hasMedia: boolean,
  background: string,
): 'light' | 'dark' =>
  hasMedia || getContrastYIQ(background) === 'white' ? 'light' : 'dark';
